import React, {useState} from "react";
import IconButton from "../../components/button/IconButton";
import ModalForm from "../../components/form/ModalForm";
import fields from "./SimpleValueMeasurementFormConfig";
import { useTranslation } from 'react-i18next';

const SimpleValueMeasurementFormConfig = ({setValue}) => {

    const [show, setShow] = useState(false)
    const { t } = useTranslation();

  return (
        <>
            <IconButton
                onClick={() => setShow(true)}
                tooltip={t("simpleValueMeasurementForm.enterMeasurement")}
                variant="outline-primary"
                icon="fa-edit"
            />

            <ModalForm
                fields={fields}
                open={show}
                title={t("simpleValueMeasurementForm.manualMeasurementEntry")}
                setOpen={setShow}
                setLoader={()=>{}}
                size={"md"}
                customSave={(form, onSaved) => {
                    setValue(form.value)
                    onSaved()
                }}
            />
        </>
    );
};

export default SimpleValueMeasurementFormConfig;
